var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCameraPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 49,
    viewBox: "0 0 55 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "jipxnk8bta",
    width: "118.1%",
    height: "115.5%",
    x: "-9%",
    y: "-7.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199491914 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6728FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#jipxnk8bta)",
    transform: "translate(-129 -3587) translate(102 3435)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.041 30.787c.938 0 1.644-.234 2.12-.703.474-.469.712-1.165.712-2.09v-9.678c0-.924-.238-1.62-.713-2.09-.475-.468-1.181-.703-2.119-.703h-2.656c-.248 0-.446-.017-.596-.053-.15-.036-.283-.098-.4-.186-.118-.088-.244-.207-.381-.356l-.752-.85c-.235-.254-.487-.446-.757-.576-.27-.13-.64-.195-1.108-.195h-3.643c-.469 0-.838.065-1.108.195-.27.13-.523.322-.757.576l-.752.85c-.215.228-.407.384-.576.468-.17.085-.433.127-.791.127h-2.578c-.944 0-1.652.235-2.124.704-.472.468-.708 1.165-.708 2.09v9.677c0 .925.236 1.621.708 2.09.472.469 1.18.703 2.124.703H31.04zm-.02-1.348H14.205c-.482 0-.851-.127-1.108-.38-.257-.254-.386-.632-.386-1.133v-9.531c0-.502.129-.881.386-1.138.257-.257.626-.386 1.108-.386h2.871c.417 0 .752-.045 1.006-.137.254-.09.498-.267.732-.527l.743-.83c.26-.293.491-.485.693-.576.202-.091.498-.137.889-.137H24c.397 0 .695.046.894.137.198.09.428.283.688.576l.742.83c.235.26.479.436.733.527.254.092.589.137 1.006.137h2.958c.482 0 .853.129 1.114.386.26.257.39.636.39 1.138v9.53c0 .502-.13.88-.39 1.134-.26.253-.632.38-1.114.38zm-8.408-1.386c.938 0 1.787-.227 2.55-.679.76-.452 1.368-1.061 1.82-1.826.453-.765.68-1.616.68-2.554 0-.937-.227-1.79-.68-2.558-.452-.769-1.06-1.379-1.82-1.832-.763-.452-1.612-.678-2.55-.678-.93 0-1.779.226-2.544.678-.765.453-1.373 1.063-1.826 1.832-.452.768-.679 1.62-.679 2.558 0 .938.227 1.789.68 2.554.452.765 1.06 1.374 1.825 1.826.765.452 1.613.679 2.544.679zm6.602-7.315c.3-.006.561-.119.786-.337.225-.218.337-.483.337-.796 0-.306-.112-.57-.337-.795-.225-.225-.487-.337-.786-.337-.313 0-.583.112-.81.337-.229.224-.343.49-.343.795 0 .32.114.588.342.806.228.218.498.327.81.327zm-6.602 6.035c-.69 0-1.32-.169-1.89-.507-.569-.339-1.025-.795-1.367-1.368-.341-.572-.512-1.207-.512-1.904 0-.703.169-1.341.508-1.914.338-.573.794-1.027 1.367-1.362.573-.336 1.204-.503 1.894-.503.697 0 1.33.167 1.9.503.57.335 1.025.79 1.367 1.362.342.573.513 1.211.513 1.914 0 .697-.171 1.332-.513 1.904-.342.573-.798 1.03-1.367 1.368-.57.338-1.203.507-1.9.507z",
    transform: "translate(32 154) translate(.011)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraPurple);
export default __webpack_public_path__ + "static/media/ic_camera_purple.a957ec16987c7c145c92d2398f82bc88.svg";
export { ForwardRef as ReactComponent };